"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _richText = require("@eventmobi/rich-text");

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _styles.makeStyles)(() => ({
  root: {
    position: 'relative',
    height: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&$richText': {
      justifyContent: 'initial'
    },
    overflow: 'hidden'
  },
  container: {
    maxHeight: '100%',
    maxWidth: '100%',
    lineHeight: 'normal',
    '&$richText': {
      width: '100%',
      marginLeft: '24px',
      marginRight: '24px'
    }
  },
  text: {
    position: 'absolute',
    bottom: '0px',
    width: '100%',
    height: 'auto',
    background: 'rgba(0, 0, 0, 0.5)',
    color: '#fff',
    boxSizing: 'border-box',
    padding: '10px',
    overflowWrap: 'break-word',
    textAlign: 'left',
    fontSize: '18px'
  },
  bgContainer: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    display: 'block',
    height: 'inherit',
    position: 'absolute',
    width: '300%',
    zIndex: '-2',
    left: '-100%'
  },
  richText: {}
}), {
  name: 'Mui-WidgetBanner'
});

var Banner = (_ref) => {
  var {
    background,
    foreground,
    richText,
    onRichTextClick,
    text,
    color,
    alt,
    crossOrigin
  } = _ref;
  var hasRichText = !!richText && !foreground;
  var classes = useStyles();
  var [loaded, setLoaded] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.bgContainer,
    style: {
      backgroundColor: color,
      backgroundImage: background ? "url(".concat(background, ")") : ''
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, {
      [classes.richText]: hasRichText
    })
  }, hasRichText && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.container, {
      [classes.richText]: hasRichText
    })
  }, /*#__PURE__*/_react.default.createElement(_richText.Renderer, {
    content: richText,
    onClick: onRichTextClick
  })), foreground && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "192px",
    height: "192px",
    className: classes.container,
    style: {
      display: foreground && !loaded ? 'inline-block' : 'none'
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    style: {
      display: loaded ? 'initial' : 'none'
    },
    className: classes.container
    /*
      This *must* be before src, due to an order-of-attributes bug
      https://github.com/facebook/react/issues/14035
       The conditional is necessary because an empty string is the same
      as setting "anonymous"; to not use CORS at all, we have to not
      set the attribute.
    */
    ,
    crossOrigin: crossOrigin || undefined,
    src: foreground,
    alt: alt,
    onLoad: () => setLoaded(true)
  })), (text === null || text === void 0 ? void 0 : text.trim()) && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    "data-testid": "overlay-text-banner",
    className: classes.text
  }, text)));
};

Banner.propTypes = {
  /**
   * The background image
   */
  background: _propTypes.default.string,

  /**
   * The overlay text
   */
  text: _propTypes.default.string,

  /**
   * The foreground image displayed in the center
   */
  foreground: _propTypes.default.string,

  /**
   * The Rich Text content as foreground
   */
  richText: _propTypes.default.string,

  /**
   * Func to control click on anchors in foreground Rich Text content
   */
  onRichTextClick: _propTypes.default.func,

  /**
   * The background color, which takes the whole screen width
   */
  color: _propTypes.default.string,

  /**
   * Alt text for the foreground image
   */
  alt: _propTypes.default.string,
  crossOrigin: _propTypes.default.string
};
var _default = Banner;
exports.default = _default;